/** Existing Products drawer vocabulary, including actions awaiting product decisions. */
export const PRODUCT_BULK_ACTIONS = {
  ELIGIBILITY_ENABLE: "PRODUCT_ELIGIBILITY_ENABLE",
  ELIGIBILITY_DISABLE: "PRODUCT_ELIGIBILITY_DISABLE",
  ELIGIBILITY_RESET: "PRODUCT_ELIGIBILITY_RESET",
  CATALOG_REPAIR_SYNC: "PRODUCT_CATALOG_REPAIR_SYNC",
  MAPPING_RECHECK: "PRODUCT_MAPPING_RECHECK",
  MONITORING_ENABLE: "PRODUCT_MONITORING_ENABLE",
  MONITORING_DISABLE: "PRODUCT_MONITORING_DISABLE",
  POLICY_APPLY: "PRODUCT_POLICY_APPLY",
  POLICY_CLEAR: "PRODUCT_POLICY_CLEAR",
} as const;
export type ProductBulkActionId = (typeof PRODUCT_BULK_ACTIONS)[keyof typeof PRODUCT_BULK_ACTIONS];
export const PRODUCT_BULK_POLICY_LIMIT = 100;
export const PRODUCT_BULK_POLICY_REASONS = {
  UNCHANGED: "PRODUCT_POLICY_UNCHANGED",
  FAILED: "PRODUCT_POLICY_FAILED",
  UNCONFIRMED: "PRODUCT_POLICY_UNCONFIRMED",
  NOT_STARTED: "PRODUCT_POLICY_NOT_STARTED",
} as const;

export const PRODUCT_BULK_ELIGIBILITY_REASONS = {
  ENABLED: "MERCHANT_BULK_ENABLED",
  DISABLED: "MERCHANT_BULK_DISABLED",
} as const;

export const PRODUCT_BULK_ELIGIBILITY_OUTCOMES = {
  UNCONFIRMED: "PRODUCT_ELIGIBILITY_UNCONFIRMED",
} as const;
